// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__CXq0X","author":"Table_author__3mnJb","authorImage":"Table_authorImage__3KD_Q","unreadRow":"Table_unreadRow__1cxt0"};